import React from 'react';
import { getFileCategory, getCategoryColor } from 'src/common/mime-types.helpers.js';
import { getExt } from 'src/documents/documents.helpers.js';
import { CpIcon } from 'canopy-styleguide!sofe';
import { featureEnabled } from 'feature-toggles!sofe';
import { shape, bool, string, object } from 'prop-types';

export default function DocIcon({ doc, isPreview, color: iconColor, style, isClientPortal = false }) {
  // Try to categorize the doc based on mime type, then extension
  const isLocked = doc.locked;
  const fileType = getFileCategory(doc.type) || getFileCategory(doc.mimetype) || getFileCategory(getExt(doc.name));
  let fileIcon = fileType && fileType !== 'word-doc' ? `file-${fileType}` : 'file-document';
  const hasChildren = doc.hasFolders || doc.hasFiles;

  let color = 'var(--cps-color-default-icon)';

  if (isLocked && !isClientPortal) {
    fileIcon = 'misc-padlock';
    color = isPreview ? 'var(--cp-color-preview-icon)' : color;
  } else if (doc.doc_type === 'folder') {
    fileIcon = `folder${doc.is_open && hasChildren ? '-open' : ''}`;
    color = isPreview ? 'var(--cp-color-preview-icon)' : color;
  } else {
    color = iconColor || (getCategoryColor(fileType, isPreview ? 'var(--cp-color-preview-icon)' : 'var(--cps-color-monsoon)'));
  }

  return (
    <span style={{color, ...style}}>
      <CpIcon name={fileIcon} />
    </span>
  );
}

DocIcon.propTypes = {
  doc: shape({
    locked: bool,
    type: string,
    mimetype: string,
    name: string,
    hasFolders: bool,
    hasFiles: bool,
  }),
  isClientPortal: bool,
  isPreview: bool,
  color: string,
  style: object,
}
